import React from 'react';

import { IPlacementInfo } from 'src/components/ListOfLayoutApartments/types';
import { IFilterHeaderInfo, ListOfKeysFilterAllData } from 'src/typings/filter';
import { useTranslations, UseNumberFormat } from 'src/hooks';
import { useGenerateShowingInfo } from '../../hooks';
import { useStyles } from './styles';

export const InfoHeader: React.FC<IPlacementInfo> = ({
  itemData,
  filterConfigurator,
  displayedType,
}) => {
  const styles = useStyles({});
  const { getTranslations } = useTranslations();
  const renderItems: { [key: string]: IFilterHeaderInfo | any } = useGenerateShowingInfo(filterConfigurator[displayedType], itemData);
  const { numberSeparator, replaceFraction } = UseNumberFormat();

  return (
    <div className={styles.apartmentHeaderInfo}>
      {Object.keys(renderItems).map((renderItem) => {
        const renderData = renderItems[renderItem];
        const placementData = itemData[renderItem];

        if (itemData[renderItem]) {
          let { color } = renderData;
          if (renderItem === ListOfKeysFilterAllData.placementStatusModuleName) {
            color = renderData.color || itemData[ListOfKeysFilterAllData.placementStatusColor];
          }
          return (
            <div
              key={renderItem}
              style={{ background: color }}
              className={styles.headerInfo}
            >
              {`${renderData['value-prefix'] || ''}`}
              {renderData['use-name'] && `${getTranslations(renderItem)}`}
              {` ${numberSeparator(replaceFraction(getTranslations(placementData)), renderItem)} `}
              {renderData['value-sufix'] || ''}
            </div>
          );
        }

        return null;
      })}
    </div>
  );
};
